<script>
  let { date, vets = $bindable([]), role = "viewer", onSelect } = $props();
  let creator = $derived(role === "admin")
  
  let buttonClass = $derived(creator ? "presence-cell cursor-pointer hover:bg-blue-50/80" : "presence-cell cursor-default");
  
  function handleSelect() {
    if (!creator) return;
    onSelect?.(date);
  }
</script>

<button class={buttonClass} onclick={handleSelect}>
  <div class="flex gap-1">
    {#each vets as vet (vet.id)}
      {@const label = vets.length === 1 ? vet.name : vet.initials}
      <span class={`bg-${vet.color} text-white text-xxs rounded-sm px-1 py-0.5`} title={vet.name}>{label}</span>
    {/each}
  </div>
</button>
